import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':itemId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:itemId`;

export const URL = (itemId: number): RouteDefinition => `${baseRoute}/${itemId}`;
